export enum EMilieuPrelevementAir {
    PCA = 1,
    SAB = 2,
    PCA_SAB = 3,
}